module.exports = __webpack_public_path__ + "b6d7d696c21aefdc79828f0d129d94be.svg";